var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Button as BSButton } from "reactstrap";
import Loader from "./Loader";
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Button.prototype.render = function () {
        var _this = this;
        var _a = this.props, text = _a.text, icon = _a.icon, iconStyle = _a.iconStyle, iconWidth = _a.iconWidth, color = _a.color, selected = _a.selected, iconSelected = _a.iconSelected, textStyle = _a.textStyle, loading = _a.loading, style = _a.style, className = _a.className, rest = __rest(_a, ["text", "icon", "iconStyle", "iconWidth", "color", "selected", "iconSelected", "textStyle", "loading", "style", "className"]);
        var finalStyle = style || {};
        if (Boolean(this.props.loading) && this.state.width) {
            finalStyle['width'] = this.state.width + 'px';
        }
        return React.createElement(BSButton, __assign({ innerRef: function (ref) {
                _this.buttonRef = ref;
                //this.props.innerRef && this.props.innerRef(ref)
            }, color: this.props.color, className: this.getClassName() }, rest, { style: finalStyle }),
            loading && React.createElement(Loader, { size: this.state.height || 30, style: { marginBottom: 0 } }),
            !loading && icon && React.createElement("img", { src: (selected && iconSelected) ? iconSelected : icon, width: iconWidth, style: __assign(__assign({}, ImageStyle), iconStyle) }),
            !loading && React.createElement("span", { style: textStyle }, text));
    };
    Button.prototype.componentWillReceiveProps = function (nextProps) {
        if (Boolean(nextProps.loading) && !Boolean(this.props.loading)) {
            if (this.buttonRef) {
                this.setState({ width: this.buttonRef.clientWidth, height: this.buttonRef.clientHeight - 10 });
            }
        }
    };
    Button.prototype.getClassName = function () {
        return 'btn-' + (this.props.selected ? 'selected' : 'unselected') + ' ' + (this.props.className || '') + ' ' + (this.props.outline ? 'outline' : '');
    };
    return Button;
}(React.PureComponent));
export default Button;
var ImageStyle = {
    marginRight: '8px'
};
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/Button.js
// module id = 112
// module chunks = 0